import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { usePostMessage, useReceiveMessage } from './messageContext';

const CalibrationContext = createContext();

export const useCalibration = () => {
  return useContext(CalibrationContext);
};

export const CalibrationProvider = ({ children }) => {
  const receivedMessage = useReceiveMessage();
  const postMessage = usePostMessage();
  const [calibrationData, setCalibrationData] = useState({
    cardDimensions: { widthPx: 355, heightPx: 222 },
    rulerDimensions: { widthMm: 600, heightMm: 340 },
    blindSpotVanishingXDistancePx: 432,
    screenWidthPx: 1920,
    screenHeightPx: 1080,
    circleDimensionsPx: 16,
    distanceFromScreen: 500,
    pixelDensity: 0.31,
    methodSelected: 'faceRecognition',
    perceivedFocalLength: 0,
    screenCalibrated: false,
    cameraCalibrated: false,
  });

  const updateCalibrationData = useCallback((newData) => postMessage({ type: 'synchroniseCalibrationData', content: newData }), [postMessage]);

  useEffect(() => {
    if (receivedMessage?.type !== 'synchroniseCalibrationData') return;
    return setCalibrationData((existingData) => {
      return { ...existingData, ...receivedMessage.content };
    });
  }, [receivedMessage]);

  return <CalibrationContext.Provider value={{ calibrationData, updateCalibrationData }}>{children}</CalibrationContext.Provider>;
};
